import React, { useState, useEffect } from 'react';
import { message, Upload, UploadFile } from 'antd';
import { InboxOutlined } from '@ant-design/icons';

const { Dragger } = Upload;

type FileDragNDropInputProps = {
    onChange: (file: UploadFile | UploadFile[]) => void;
    maxCount: number;
    uploadText: string;
    uploadHint: string;
    color: string;
};
const FileDragNDropInput = ({
    onChange,
    maxCount = 1,
    uploadText = 'Glissez déposez ou sélectionnez un fichier',
    uploadHint = 'Ajoutez ici un document (PDF, JPEG, PDF) lié à l\'affaire.',
    color = '#E36D38'
}: FileDragNDropInputProps) => {

    const [localFileList, setLocalFileList] = useState<UploadFile[]>([]);

    const handleRemove = (file: UploadFile) => {
        const updatedFileList = localFileList.filter(item => item.uid !== file.uid);
        setLocalFileList(updatedFileList);
        message.success(`${file.name} supprimé`);
    };

    const handleBeforeUpload = (file: UploadFile) => {
        setLocalFileList([file]);
        message.success(`${file.name} ajouté`);

        return false;
    };

    useEffect(() => {
        onChange(maxCount > 1 ? localFileList : localFileList[0]);
    }, [localFileList, maxCount, onChange]);

    const props = {
        onRemove: handleRemove,
        beforeUpload: handleBeforeUpload,
        maxCount,
        fileList: localFileList
    };

    return (
        <div className=''>
            <Dragger {...props}>
                <InboxOutlined
                    style={{
                        color: color,
                        fontSize: "42px",
                        width: "968px",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                />
                <p className="ant-upload-text">{uploadText}</p>
                <p className="ant-upload-hint">{uploadHint}</p>
            </Dragger>
        </div>
    )
}

export default FileDragNDropInput;
